import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CardSettlementBatchDto,
  CardSettlementBatchListDto,
  CardSettlementBatchFilterDto,
  ImportSettlementBatchRequest,
} from '@/types/cardReconciliation.types';

export const cardSettlementApi = {
  /** GET /api/v1/card-settlements — paginated list */
  getList: (filter?: CardSettlementBatchFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CardSettlementBatchListDto>>>('/card-settlements', { params: filter }),

  /** GET /api/v1/card-settlements/{id} */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CardSettlementBatchDto>>(`/card-settlements/${id}`),

  /** POST /api/v1/card-settlements/import */
  import: (data: ImportSettlementBatchRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/card-settlements/import', data),
};
